import AnalyzePlansAndRates from './pages/Analyze/AnalyzePlansAndRates'
import AnalyzeSmokerRates from './pages/Analyze/AnalyzeSmokerRates'
import PlanManagementHome from './pages/Home/PlanManagementHome'
import {
  PLAN_MANAGEMENT,
  PLANS_AND_RATES_ANALYZE,
  SERVICE_AREAS_ANALYZE,
  SMOKER_RATES_ANALYZE,
} from './paths'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PageWrapper from 'enrollment-platform/PageWrapper'
import AnalyzeServiceAreas from './pages/Analyze/AnalyzeServiceAreas'

const PlanManagementRoutes = [
  {
    path: PLAN_MANAGEMENT,
    component: PageWrapper,
    onEnter(
      _nextState: unknown,
      _replace: unknown,
      callback: (err?: { status: number; message: string }) => void
    ) {
      // Plan Management is a PlatformHixmeAdmin-only surface (hixmeOnlyLinks),
      // so a coarse role gate suffices; HixmeAdmin passes the server ability
      // check via the Manage/all wildcard regardless.
      authOnEnter({ allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN], callback })
    },
    indexRoute: {
      component: PlanManagementHome,
    },
    childRoutes: [
      {
        path: PLANS_AND_RATES_ANALYZE,
        component: AnalyzePlansAndRates,
      },
      {
        path: SMOKER_RATES_ANALYZE,
        component: AnalyzeSmokerRates,
      },
      {
        path: SERVICE_AREAS_ANALYZE,
        component: AnalyzeServiceAreas,
      },
    ],
  },
]

export default PlanManagementRoutes
